import { Button } from 'antd'
import UserAvatar from '../common/UserAvatar'
import { useEffect, useRef, useState } from 'react'
import { parseCommentContentToElements } from '../../utils/commentParser'
import '../../styles/components/comment/CommentItem.css'

/**
 * 单条评论/回复展示组件
 * @param {{
 *  comment: object,
 *  onReply?: (comment)=>void,
 *  onLike?: (id)=>void,
 *  onMentionClick?: (userId)=>void
 * }} props
 */
export default function CommentItem({ comment, onReply, onLike, onMentionClick }) {
  const elements = parseCommentContentToElements(comment?.fields?.content || comment?.content || '')
  const replyTarget = comment?.reply_to_user || comment?.fields?.reply_to_user
  const replyPrefix = replyTarget?.name
  const [expanded, setExpanded] = useState(false)
  const [overflow, setOverflow] = useState(false)
  const contentRef = useRef()
  const clampLines = 3
  useEffect(() => {
    const text = elements.map((e) => e.text).join('')
    const lines = (text.match(/\n/g) || []).length + 1
    let isOverflow = lines > clampLines
    const el = contentRef.current
    if (el) {
      try {
        if (el.scrollHeight > el.clientHeight) isOverflow = true
      } catch {}
    }
    setOverflow(isOverflow)
  }, [elements, expanded])
  return (
    <div className="comment-item-row">
      <div className="comment-header">
        <UserAvatar size={24} user={comment?.user} />
        <div className="comment-user-name">{comment?.user?.name || 'Unknown User'}</div>
        <div className="comment-timestamp">{new Date(comment?.inserted_at || comment?.updated_at || Date.now()).toLocaleString()}</div>
      </div>
      <div ref={contentRef} data-testid="comment-content" className={`comment-content${expanded ? '' : ' clamped'}`}>
        {replyPrefix && (
          <span className="reply-prefix">
            回复 <a className="mention-link" onClick={() => onMentionClick?.(replyTarget?.id)}>@{replyPrefix}</a>：
          </span>
        )}
        {elements.map((el, idx) => el.type === 'mention' ? (
          <a key={idx} className="mention-link" onClick={() => onMentionClick?.(el.userId)}>{el.text}</a>
        ) : (
          <span key={idx}>{el.text}</span>
        ))}
      </div>
      {overflow && (
        <div className="comment-toggle-row">
          <Button data-testid="comment-toggle" type="link" size="small" onClick={() => setExpanded((v) => !v)}>{expanded ? '收起' : '展开全部'}</Button>
        </div>
      )}
      <div className="comment-actions">
        <Button type="link" onClick={() => onReply?.(comment)}>回复</Button>
        <Button type="link" onClick={() => onLike?.(comment?.id)}>{comment?.is_liked ? '取消点赞' : '点赞'}{typeof comment?.interactions?.like_count === 'number' ? ` (${comment.interactions.like_count})` : ''}</Button>
      </div>
    </div>
  )
}
